import { BaseComponent } from '../../components/base-component'
import { HotspotsFloatElement } from './hotspots-float-element'
import { ModalComponent } from '../../components/modal/modal'
import { FloatElementBtn } from 'src/scripts/components/float-element'
import { $list, $elParent, whenDefined } from 'src/scripts/utils/utils'

const MODAL_SELECTOR = 'modal-component'
const HOTSPOTS_FLOAT_ELEMENT = 'hotspots-float-element'
const FLOAT_ELEMENT_BTN_SELECTOR = 'float-element-btn'

export class HotspotsComponent extends BaseComponent {
  hasOpenFloatElement: boolean

  mountComponent(): void {
    const modals: ModalComponent[] = $list(MODAL_SELECTOR, this)
    const floatElements: HotspotsFloatElement[] = $list(
      HOTSPOTS_FLOAT_ELEMENT,
      this,
    )
    const floatElementsBtns: FloatElementBtn[] = $list(
      FLOAT_ELEMENT_BTN_SELECTOR,
      this,
    )

    modals.forEach(modal => {
      whenDefined('modal-component').then(() => {
        modal.on('show', this.handleModalOpen)
        modal.on('hide', this.handleModalHide)
      })
    })

    floatElements.forEach(floatElement => {
      whenDefined('hotspots-float-element').then(() => {
        floatElement.on('hide', this.handleFloatElementHide)
        floatElement.on('show', this.handleFloatElementShow)
      })
    })

    floatElementsBtns.forEach(btn => {
      this.addListener(btn, 'mouseenter', this.handlePinBtnEnter)
      this.addListener(btn, 'mouseleave', this.handlePinBtnLeave)
      this.addListener(btn, 'click', this.handlePinBtnClick)
    })

    if (this.isEditor) {
      this.addListener(window, 'click', this.handleEditorClick)
    }
  }

  unmountComponent(): void {
    const modals: ModalComponent[] = $list(MODAL_SELECTOR, this)
    const floatElements: HotspotsFloatElement[] = $list(
      HOTSPOTS_FLOAT_ELEMENT,
      this,
    )

    modals.forEach(modal => {
      whenDefined('modal-component').then(() => {
        modal.off('show', this.handleModalOpen)
        modal.off('hide', this.handleModalHide)
      })
    })

    floatElements.forEach(floatElement => {
      whenDefined('hotspots-float-element').then(() => {
        floatElement.off('hide', this.handleFloatElementHide)
        floatElement.off('show', this.handleFloatElementShow)
      })
    })
  }

  handlePinBtnClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.setAttribute('animation-state', 'pause')
  }

  handlePinBtnEnter = (event: MouseEvent): void => {
    event.preventDefault()
    this.setAttribute('animation-state', 'pause')
  }

  handlePinBtnLeave = (event: MouseEvent): void => {
    event.preventDefault()

    if (this.hasOpenFloatElement) {
      return
    }

    this.removeAttribute('animation-state')
  }

  handleFloatElementShow = () => {
    this.hasOpenFloatElement = true
  }

  handleFloatElementHide = () => {
    this.hasOpenFloatElement = false
    this.removeAttribute('animation-state')
  }

  handleModalOpen = (): void => {
    this.setAttribute('animation-state', 'pause')
  }

  handleModalHide = (): void => {
    this.removeAttribute('animation-state')
  }

  handleEditorClick = (event: MouseEvent): void => {
    const isTriggerBtn: FloatElementBtn = $elParent(
      FLOAT_ELEMENT_BTN_SELECTOR,
      event.target,
    )
    const isFloatElement: HotspotsFloatElement = $elParent(
      HOTSPOTS_FLOAT_ELEMENT,
      event.target,
    )
    const floatElements: HotspotsFloatElement[] = $list(
      HOTSPOTS_FLOAT_ELEMENT,
      this,
    )

    if (isTriggerBtn || isFloatElement) {
      return
    }

    floatElements.forEach(floatElement => {
      floatElement.hide()
    })
  }
}
